import React, { useEffect, useMemo, useState, useRef } from "react";
import { Box, Card, Checkbox, Grid, Stack, Typography, TextField, Select, MenuItem, FormGroup, FormControlLabel, IconButton, FormControl, InputLabel, FormHelperText, ListItemText } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import CommonLayout from "layouts/DashboardLayout";
import MDButton from "components/MDButton";
import ReactSelect, { components as ReactSelectComponents } from "react-select";
import { useDispatch } from "react-redux";
import { addProductCarousel, fetchProductDeatilsCarousel, openSnackbar } from "../../../redux/slices/common";
import AngleRightIcon from 'common/customIcons/angle_right';
import { fetchBrandsPlatform, fetchProductCategoriesProduct } from "../../../redux/slices/brand";
import { getSubTraitCarouselListing, getSubTraitListing } from "../../../redux/slices/subtraitSlice";
import { useSelector } from "react-redux";
import { fetchStoresAPIs } from "../../../redux/slices/storeSlice";
import ProductTable from "./ProductTable";
import Loader from "common/Loader";
import ViewCarousel from "./ViewCarousel";
import ProductTableView from "./ProductTableView";
import ViewCarouselFilters from "./ViewCarouselFilters";

export default function AddCarousel() {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const fullRoleTab = useMemo(() => searchParams.get('platform'), [searchParams]);
    const CarouselId = useMemo(() => searchParams.get('carouselId'), [searchParams]);
    const CarouselView = useMemo(() => searchParams.get('view'), [searchParams]);

    const navigate = useNavigate();
    const [carouselName, setCarouselName] = useState('');
    const { isupdateLoading = false, isLoading } = useSelector(state => state.common);
    const { user = {} } = useSelector(state => state.auth);
    const [storeId, setStoreId] = useState('')
    const [errors, setErrors] = useState({
        carouselName: false,
        storeId: false,
        pageId: false,
        minProducts: false,
        minQtyInvalid: false,
        maxProducts: false,
        maxLessThanMin: false,
        noSelection: false

    });

    const [filters, setFilters] = useState({
        categories: [],
        brands: [],
        traits: [],
        pageId: [],
        strains: [],
        productLimit: {
            "min": '',
            "max": ''
        }
    });
    const { stores } = useSelector((state) => state.stores);

    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState([]);
    const [mainTraitData, setMainTraitData] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [isBrandsLoading, setIsBrandsLoading] = useState(false);
    const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);
    const [isTraitsLoading, setIsTraitsLoading] = useState(false);

    const handleClear = () => {
        setSearchParams({
            platform: fullRoleTab,
            carouselId: ""
        });
        setCarouselName("")
        setStoreId("")
        setFilters({
            categories: [],
            brands: [],
            traits: [],
            pageId: [],
            strains: [],
            productLimit: {
                "min": '',
                "max": ''
            }
        })
    }
    // --------------------------------Brand----------------------------------------

    useEffect(() => {
        (async () => {
            setIsBrandsLoading(true);
            try {
                const response = await dispatch(fetchBrandsPlatform({ skip: 0, limit: 1000, userType: 'admin', platform: fullRoleTab ? fullRoleTab.toLowerCase() : "hyperwolf" })).unwrap();
                const data = fullRoleTab === 'Hyperwolf' ? response?.values || [] : response?.brands || [];
                setBrands(data);
            } catch (error) {
                const msg = error?.message || error?.data?.message || "Failed to load brands";
                dispatch(openSnackbar({ content: msg, color: "error", icon: "warning" }));
            } finally {
                setIsBrandsLoading(false);
            }
        })();
    }, [dispatch, fullRoleTab]);

    const brandOptions = useMemo(() => {
        const options = (brands || [])
            .slice()
            .filter(t => (t.brandactive === true || t.status === "active"))
            .map((b) => ({
                value: b.brandId || b.id,
                label: b.brandName || b.name,
                brandId: b.brandId || b.id,
                brandName: b.brandName || b.name,
                brandSlug: b.brandSlug || b.brandName?.toLowerCase()
            }));

        // Add select all option at the beginning
        return [{ value: 'select-all', label: 'Select All' }, ...options];
    }, [brands]);


    const selectedBrandOptions = useMemo(() => {
        return brandOptions.filter(opt =>
            filters?.brands?.some(brand => brand.brandId === opt.brandId)
        );
    }, [brandOptions, filters.brands]);

    // ----------------------------------Category--------------------------------------

    useEffect(() => {
        (async () => {
            setIsCategoriesLoading(true);
            try {
                const response = await dispatch(fetchProductCategoriesProduct({ platform: fullRoleTab ? fullRoleTab.toLowerCase() : "hyperwolf", skip: 0, limit: 100, userType: 'admin' })).unwrap();
                const data = response?.categories || [];
                setCategories(data);
            } catch (error) {
                const msg = error?.message || error?.data?.message || "Failed to load categories";
                dispatch(openSnackbar({ content: msg, color: "error", icon: "warning" }));
            } finally {
                setIsCategoriesLoading(false);
            }
        })();
    }, [dispatch, fullRoleTab]);

    const categoryOptions = useMemo(() => {
        const options = (categories || [])
            .slice()
            .filter(c => c.categoryName || c.name)
            .map((c) => ({
                value: c.categoryId || c.id,
                label: c.categoryName || c.name,
                categoryId: c.categoryId || c.id,
                categoryName: c.categoryName || c.name,
                categorySlug: c.categorySlug || (c.categoryName || c.name)?.toLowerCase()
            }));

        // Add select all option at the beginning
        return [{ value: 'select-all', label: 'Select All' }, ...options];
    }, [categories]);

    const selectedCategoryOptions = useMemo(() => {
        return categoryOptions.filter(opt =>
            filters?.categories?.some(cat => cat.categoryId === opt.categoryId)
        );
    }, [categoryOptions, filters.categories]);

    // ------------------------------------------traits------------------------------------
    useEffect(() => {
        (async () => {
            setIsTraitsLoading(true);
            try {
                const response = await dispatch(getSubTraitCarouselListing({ productCarousel: true, platformType: fullRoleTab ? fullRoleTab.toLowerCase() : "hyperwolf", skip: 0, limit: 200, userType: 'admin' })).unwrap();
                const data = response?.subTraits || [];
                setMainTraitData(data);
            } catch (error) {
                const msg = error?.message || error?.data?.message || "Failed to load traits";
                dispatch(openSnackbar({ content: msg, color: "error", icon: "warning" }));
            } finally {
                setIsTraitsLoading(false);
            }
        })();
    }, [dispatch, fullRoleTab]);
    const traitOptions = useMemo(() => {
        const options = (mainTraitData || [])
            .slice()
            .map((t) => ({
                value: t.subTraitName,
                label: t.subTraitName,
                subTraitSlug: t.traitSlug,
                subTraitName: t.subTraitName
            }));

        // Add select all option at the beginning
        return [{ value: 'select-all', label: 'Select All' }, ...options];
    }, [mainTraitData]);

    const selectedTraitOptions = useMemo(() => {
        return traitOptions.filter(opt =>
            filters?.traits?.some(trait => trait.subTraitName === opt.subTraitName)
        );
    }, [traitOptions, filters.traits]);

    // =----------------------------------------------------------------------
    const pageOptions = [
        { value: "select-all", label: "Select All" },
        { value: "Blog Detail Pages", label: "Blog Detail Pages" },
        { value: "Cannabinoids Detail Pages", label: "Cannabinoids Detail Pages" },
        { value: "Cultivation Style Detail Pages", label: "Cultivation Style Detail Pages" },
        { value: "Product Detail Pages", label: "Product Detail Pages" },
        { value: "Strains Detail Pages", label: "Strains Details Pages" },
        { value: "Terpenes Detail Pages", label: "Terpenes Detail pages" },
    ]

    const selectedPageOptions = useMemo(() => {
        const set = new Set(filters.pageId || []);
        return pageOptions.filter((opt) => set.has(opt.value));
    }, [pageOptions, filters.pageId]);


    const CheckboxOption = (props) => {
        const { children, ...rest } = props;
        const isSelectAll = props.data && props.data.value === 'select-all';

        // For select all option
        if (isSelectAll) {
            const allOptions = props.selectProps.options.filter(opt => opt.value !== 'select-all');
            const allSelected = allOptions.length > 0 && allOptions.every(opt =>
                props.getValue().some(selected => selected.value === opt.value)
            );

            return (
                <div
                    onClick={() => {
                        if (allSelected) {
                            props.setValue([], 'deselect-option');
                        } else {
                            props.setValue(allOptions, 'select-option');
                        }
                    }}
                    style={{ cursor: 'pointer', padding: '8px 10px', display: 'flex', alignItems: 'center' }}
                >
                    <Checkbox
                        checked={allSelected}
                        indeterminate={!allSelected && allOptions.some(opt =>
                            props.getValue().some(selected => selected.value === opt.value)
                        )}
                        sx={{ p: 0, mr: 1 }}
                    />
                    <span style={{ fontWeight: 'bold' }}>Select All</span>
                </div>
            );
        }

        // For regular options
        return (
            <ReactSelectComponents.Option {...rest}>
                <Checkbox
                    checked={props.isSelected}
                    sx={{ p: 0, mr: 1 }}
                />
                {children}
            </ReactSelectComponents.Option>
        );
    };

    const validateForm = () => {
        const isAtLeastOneSelected =
            (filters.categories && filters.categories.length > 0) ||
            (filters.brands && filters.brands.length > 0) ||
            (filters.products && filters.products.length > 0);

        const minQty = filters.productLimit.min ? parseInt(filters.productLimit.min, 10) : null;
        const maxQty = filters.productLimit.max ? parseInt(filters.productLimit.max, 10) : null;
        const MINIMUM_QTY = 5;

        const newErrors = {
            carouselName: !carouselName.trim(),
            storeId: fullRoleTab === 'Stilo' ? !storeId : false,
            pageId: !filters.pageId || filters.pageId.length === 0,
            minProducts: !filters.productLimit.min,
            minQtyInvalid: minQty !== null && minQty < MINIMUM_QTY,
            maxProducts: !filters.productLimit.max,
            maxLessThanMin: maxQty !== null && minQty !== null && maxQty < minQty,
            noSelection: !isAtLeastOneSelected
        };

        setErrors(newErrors);
        return !Object.values(newErrors).some(error => error);
    };



    const handleNumberInput = (e, field) => {
        // Remove non-numeric characters and limit to 8 digits
        const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 2);
        const numValue = value ? parseInt(value, 10) : '';
        const MINIMUM_QTY = 5;

        setFilters(prev => {
            const newFilters = {
                ...prev,
                productLimit: {
                    ...prev.productLimit,
                    [field]: value
                }
            };

            // Validate min and max values
            const minValue = newFilters.productLimit.min ? parseInt(newFilters.productLimit.min, 10) : null;
            const maxValue = newFilters.productLimit.max ? parseInt(newFilters.productLimit.max, 10) : null;

            // Check for minimum quantity validation
            const isMinInvalid = field === 'min' && numValue !== '' && numValue < MINIMUM_QTY;

            // Check if max is less than min (only if both have values)
            const isMaxLessThanMin = minValue !== null && maxValue !== null && maxValue < minValue;

            setErrors(prev => ({
                ...prev,
                minProducts: !newFilters.productLimit.min || isMinInvalid,
                minQtyInvalid: isMinInvalid,
                maxProducts: !newFilters.productLimit.max,
                maxLessThanMin: isMaxLessThanMin
            }));

            return newFilters;
        });
    };

    const handleApplyButton = () => {
        if (!validateForm()) {
            return;
        }
        const payload = {
            "title": carouselName,
            "platformType": fullRoleTab,
            "placement": filters.pageId,
            "categories": filters?.categories,
            "brands": filters?.brands,
            "traits": filters?.traits,
            "productLimit": {
                "min": Number(filters?.productLimit?.min),
                "max": Number(filters?.productLimit?.max)
            },
            "createdBy": user?.name,
            "strains": filters.strains
        }
        if (fullRoleTab === 'Stilo') {
            payload.storeId = storeId
        }

        dispatch(addProductCarousel({ data: payload, CarouselId: CarouselId ? CarouselId : "" })).unwrap().then((res) => {
            showMessage(res?.message, 'success');

            const updatedCarouselId = res?.data?._id || CarouselId;
            setSearchParams({
                platform: fullRoleTab,
                carouselId: updatedCarouselId
            });

            // Trigger ProductTable refresh after successful update
            if (CarouselId) {
                setRefreshKey(prev => prev + 1);
            }

        }).catch((err) => {

            showMessage(err?.message, 'error');
        });
    }

    const showMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
        }
    };

    useEffect(() => {
        dispatch(fetchStoresAPIs({ skip: 0, limit: 100 }))
            .then((res) => { })
            .catch((err) => { });

        if (CarouselId) {
            dispatch(fetchProductDeatilsCarousel(CarouselId))
                .then((res) => {
                    const resData = res?.payload?.data
                    setCarouselName(resData?.title)
                    setStoreId(resData?.storeId)
                    setFilters({
                        categories: resData?.categories,
                        brands: resData?.brands,
                        traits: resData?.traits,
                        pageId: resData?.placement,
                        strains: resData?.strains,
                        productLimit: {
                            "min": resData?.productLimit?.min,
                            "max": resData?.productLimit?.max,
                        },
                        products: resData?.products
                    })
                })
                .catch((err) => { });
        }
    }, []);


    return (
        <CommonLayout>

            <Box p={{ xs: 2, sm: 3, lg: 4 }} className="add-carousel-page">
                <Stack direction="row" justifyContent="space-between" flexWrap="wrap" alignItems="stretch" gap={2} mb={1}>
                    <span
                        onClick={() => navigate(`/hyperwolf/product-carousels?platform=${fullRoleTab || 'Hyperwolf'}`, { replace: true })}
                        className='d-flex align-item-center cur-pointer'
                    >
                        <Box display="flex" alignItems="center" color='text.main' lineHeight={1}>
                            <IconButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/hyperwolf/product-carousels?platform=${fullRoleTab || 'Hyperwolf'}`, { replace: true });
                                }}
                                size="small"
                                style={{ padding: "0" }}
                            >
                                <AngleRightIcon fontSize="14px" />
                            </IconButton>
                            <Typography variant="h6" fontWeight="semibold" ml={1}> {CarouselView === 'true' ? "View" : CarouselId ? "Update" : "Add"} Carousel</Typography>
                        </Box>
                    </span>
                    <Typography variant="body2" fontWeight="medium" color="#0163FF" style={{ background: "#dbe9ff", padding: "8px", minWidth: "120px", maxWidth: "max-content", borderRadius: "40px", textAlign: "center" }}>
                        {fullRoleTab ? fullRoleTab : "-"}
                    </Typography>
                </Stack>
                {
                    isLoading ? <Loader /> :
                        <Grid container spacing={3} mb={3}>
                            {
                                CarouselView !== 'true' &&
                                <Grid item xs={12} md={8}>
                                    <Card sx={{ borderRadius: 2.5, boxShadow: "none", p: 3 }}>
                                        <Grid container spacing={2.5}>
                                            <Grid item xs={12} md={6}>
                                                <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                                                    Carousel Name
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    // label="Carousel Name"
                                                    value={carouselName}
                                                    onChange={(e) => { setCarouselName(e.target.value), setErrors({ ...errors, carouselName: false }) }}
                                                    error={errors.carouselName}
                                                    helperText={errors.carouselName ? 'Carousel Name is required' : ''}
                                                />
                                            </Grid>
                                            {
                                                fullRoleTab.toLowerCase() === 'stilo' &&
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth className="select-store">
                                                        <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                                                            Select Store
                                                        </Typography>
                                                        {/* <InputLabel>Select Store</InputLabel> */}
                                                        <Select
                                                            value={storeId}
                                                            onChange={(e) => { setStoreId(e.target.value); setErrors({ ...errors, storeId: false }) }}
                                                            name="role"
                                                            // label="Select Store"
                                                            fullWidth
                                                            className="form-select select-field-icon"
                                                        >
                                                            {stores?.stores?.map((role, idx) => {
                                                                return (
                                                                    <MenuItem value={role?.storeId} key={idx}>
                                                                        {role?.storeName}
                                                                    </MenuItem>
                                                                );
                                                            })}
                                                        </Select>
                                                        {Boolean(errors?.storeId) && <FormHelperText error>{errors?.storeId ? 'Store Name is Required' : ''}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>
                                            }

                                            <Grid item xs={12} md={12} className="cus-multi-select">
                                                <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                                                    Select Brands
                                                </Typography>
                                                <ReactSelect
                                                    className="cus-react-select"
                                                    isMulti
                                                    isSearchable
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    isLoading={isBrandsLoading}
                                                    loadingMessage={() => 'Loading brands...'}
                                                    noOptionsMessage={() => isBrandsLoading ? 'Loading...' : 'No brands found'}
                                                    options={isBrandsLoading ? [] : brandOptions}
                                                    value={selectedBrandOptions}
                                                    onChange={(opts) => {
                                                        const selectedBrands = (opts || []).map(opt => ({
                                                            brandId: opt.brandId,
                                                            brandName: opt.brandName,
                                                            brandSlug: opt.brandSlug
                                                        }));
                                                        setErrors({ ...errors, noSelection: false })
                                                        setFilters(prev => ({ ...prev, brands: selectedBrands }));
                                                    }}
                                                    placeholder={isBrandsLoading ? 'Loading brands...' : 'Search & select brands'}
                                                    components={{
                                                        IndicatorSeparator: null,
                                                        MultiValue: (props) => {
                                                            const { index, getValue } = props;
                                                            const values = getValue();
                                                            const maxToShow = 5;
                                                            
                                                            if (index < maxToShow) {
                                                                return <ReactSelectComponents.MultiValue {...props} />;
                                                            } else if (index === maxToShow) {
                                                                return (
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        backgroundColor: '#f0f0f0',
                                                                        borderRadius: '4px',
                                                                        padding: '2px 8px',
                                                                        margin: '2px',
                                                                        fontSize: '14px',
                                                                        color: '#555'
                                                                    }}>
                                                                        +{values.length - maxToShow} more
                                                                    </div>
                                                                );
                                                            }
                                                            return null;
                                                        },
                                                        Option: CheckboxOption,
                                                        LoadingIndicator: null,
                                                        MenuList: (props) => {
                                                            const { children, ...rest } = props;
                                                            return (
                                                                <ReactSelectComponents.MenuList {...rest}>
                                                                    {children}
                                                                </ReactSelectComponents.MenuList>
                                                            );
                                                        }
                                                    }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            minHeight: 40,
                                                            opacity: isBrandsLoading ? 0.7 : 1,
                                                        }),
                                                        multiValue: (provided, state) => ({
                                                            ...provided,
                                                            maxWidth: '100%',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        }),
                                                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12}>
                                                <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                                                    Select Categories
                                                </Typography>
                                                <ReactSelect
                                                    className="cus-react-select"
                                                    isMulti
                                                    isSearchable
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    isLoading={isCategoriesLoading}
                                                    loadingMessage={() => 'Loading categories...'}
                                                    noOptionsMessage={() => isCategoriesLoading ? 'Loading...' : 'No categories found'}
                                                    options={isCategoriesLoading ? [] : categoryOptions}
                                                    value={selectedCategoryOptions}
                                                    onChange={(opts) => {
                                                        const selectedCategories = (opts || []).map(opt => ({
                                                            categoryId: opt.categoryId || opt.value,
                                                            categoryName: opt.categoryName || opt.label,
                                                            categorySlug: opt.categorySlug || opt.value
                                                        }));
                                                        setErrors({ ...errors, noSelection: false })
                                                        setFilters(prev => ({ ...prev, categories: selectedCategories }));
                                                    }}
                                                    placeholder={isCategoriesLoading ? 'Loading categories...' : 'Search & select categories'}
                                                    components={{
                                                        IndicatorSeparator: null,
                                                        MultiValue: (props) => {
                                                            const { index, getValue } = props;
                                                            const values = getValue();
                                                            const maxToShow = 5;
                                                            
                                                            if (index < maxToShow) {
                                                                return <ReactSelectComponents.MultiValue {...props} />;
                                                            } else if (index === maxToShow) {
                                                                return (
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        backgroundColor: '#f0f0f0',
                                                                        borderRadius: '4px',
                                                                        padding: '2px 8px',
                                                                        margin: '2px',
                                                                        fontSize: '14px',
                                                                        color: '#555'
                                                                    }}>
                                                                        +{values.length - maxToShow} more
                                                                    </div>
                                                                );
                                                            }
                                                            return null;
                                                        },
                                                        Option: CheckboxOption,
                                                        LoadingIndicator: null,
                                                        MenuList: (props) => {
                                                            const { children, ...rest } = props;
                                                            return (
                                                                <ReactSelectComponents.MenuList {...rest}>
                                                                    {children}
                                                                </ReactSelectComponents.MenuList>
                                                            );
                                                        }
                                                    }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            minHeight: 40,
                                                            opacity: isCategoriesLoading ? 0.7 : 1,
                                                        }),
                                                        multiValue: (provided, state) => ({
                                                            ...provided,
                                                            maxWidth: '100%',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        }),
                                                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12}>
                                                <Box display="flex" alignItems="center" gap={2} mb={1}>
                                                    <Typography variant="body2" fontWeight="semibold" color="#2E2E3A">
                                                        Select Strain Type
                                                    </Typography>
                                                    <FormGroup className="checkbox-ui selct-all-checkbox" row>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={['Sativa', 'Indica', 'Hybrid'].every(strain => 
                                                                        filters?.strains?.some(s => s.strainType === strain)
                                                                    )}
                                                                    indeterminate={
                                                                        filters?.strains?.length > 0 && 
                                                                        filters.strains.length < 3
                                                                    }
                                                                    onChange={(e) => {
                                                                        const allStrains = ['Sativa', 'Indica', 'Hybrid'];
                                                                        if (e.target.checked) {
                                                                            setFilters(prev => ({
                                                                                ...prev,
                                                                                strains: allStrains.map(strain => ({
                                                                                    strainType: strain,
                                                                                    strainSlug: strain.toLowerCase()
                                                                                }))
                                                                            }));
                                                                        } else {
                                                                            setFilters(prev => ({
                                                                                ...prev,
                                                                                strains: []
                                                                            }));
                                                                        }
                                                                    }}
                                                                />
                                                            }
                                                            label="Select All"
                                                            sx={{ width: '100%', mb: 1, ml: 0 }}
                                                        />
                                                    </FormGroup>
                                                </Box>
                                                <FormGroup className="checkbox-ui" row>
                                                    {['Sativa', 'Indica', 'Hybrid'].map((strain) => (
                                                        <FormControlLabel
                                                            key={strain}
                                                            control={
                                                                <Checkbox
                                                                    checked={filters?.strains?.some(s => s.strainType === strain)}
                                                                    onChange={(e) => {
                                                                        const isChecked = e.target.checked;
                                                                        setFilters(prev => {
                                                                            if (isChecked) {
                                                                                return {
                                                                                    ...prev,
                                                                                    strains: [
                                                                                        ...prev.strains,
                                                                                        {
                                                                                            strainType: strain,
                                                                                            strainSlug: strain.toLowerCase()
                                                                                        }
                                                                                    ]
                                                                                };
                                                                            } else {
                                                                                return {
                                                                                    ...prev,
                                                                                    strains: prev.strains.filter(s => s.strainType !== strain)
                                                                                };
                                                                            }
                                                                        });
                                                                    }}
                                                                />
                                                            }
                                                            label={strain}
                                                        />
                                                    ))}
                                                </FormGroup>
                                            </Grid>

                                            <Grid item xs={12} md={12}>
                                                <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                                                    Select Product Traits
                                                </Typography>
                                                <ReactSelect
                                                    className="cus-react-select"
                                                    isMulti
                                                    isSearchable
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    options={traitOptions}
                                                    value={selectedTraitOptions}
                                                    onChange={(opts) => {
                                                        const selectedTraits = (opts || []).map(opt => ({
                                                            subTraitSlug: opt.subTraitSlug || opt.value,
                                                            subTraitName: opt.subTraitName || opt.label.split(' > ')[1] || opt.label
                                                        }));
                                                        setFilters(prev => ({ ...prev, traits: selectedTraits }));
                                                    }}
                                                    placeholder="Search & select product traits"
                                                    components={{
                                                        IndicatorSeparator: null,
                                                        MultiValue: (props) => {
                                                            const { index, getValue } = props;
                                                            const values = getValue();
                                                            const maxToShow = 5;
                                                            
                                                            if (index < maxToShow) {
                                                                return <ReactSelectComponents.MultiValue {...props} />;
                                                            } else if (index === maxToShow) {
                                                                return (
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        backgroundColor: '#f0f0f0',
                                                                        borderRadius: '4px',
                                                                        padding: '2px 8px',
                                                                        margin: '2px',
                                                                        fontSize: '14px',
                                                                        color: '#555'
                                                                    }}>
                                                                        +{values.length - maxToShow} more
                                                                    </div>
                                                                );
                                                            }
                                                            return null;
                                                        },
                                                        Option: CheckboxOption,
                                                    }}
                                                    styles={{
                                                        control: (provided) => ({ 
                                                            ...provided, 
                                                            minHeight: 40 
                                                        }),
                                                        multiValue: (provided, state) => ({
                                                            ...provided,
                                                            maxWidth: '100%',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        }),
                                                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                                                    }}
                                                />
                                            </Grid>


                                            <Grid item xs={12} md={12}>
                                                <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                                                    Select Page
                                                </Typography>
                                                <ReactSelect
                                                    className="cus-react-select"
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    placeholder="Search & select pages"
                                                    options={pageOptions}
                                                    value={selectedPageOptions}
                                                    onChange={(opts) => {
                                                        setErrors({
                                                            ...errors,
                                                            pageId: false
                                                        });
                                                        
                                                        const selectedValues = Array.isArray(opts)
                                                            ? opts.map((o) => o.value)
                                                            : [opts?.value].filter(Boolean);
                                                        
                                                        // Handle select all/deselect all
                                                        if (selectedValues.includes('select-all')) {
                                                            // If select-all is selected, select all pages except the select-all option
                                                            const allPageValues = pageOptions
                                                                .filter(opt => opt.value !== 'select-all')
                                                                .map(opt => opt.value);
                                                            setFilters(prev => ({
                                                                ...prev,
                                                                pageId: allPageValues
                                                            }));
                                                        } else if (opts.some(opt => opt.value === 'select-all')) {
                                                            // If select-all was previously selected but now being deselected, clear all
                                                            setFilters(prev => ({
                                                                ...prev,
                                                                pageId: []
                                                            }));
                                                        } else {
                                                            // Normal selection/deselection
                                                            setFilters(prev => ({
                                                                ...prev,
                                                                pageId: selectedValues
                                                            }));
                                                        }
                                                    }}
                                                    components={{
                                                        IndicatorSeparator: null,
                                                        Option: CheckboxOption,
                                                    }}
                                                    styles={{
                                                        control: (provided) => ({ ...provided, minHeight: 40 }),
                                                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                                                    }}
                                                />
                                                {Boolean(errors?.pageId) && <FormHelperText error>{errors?.pageId ? 'Page Name is Required' : ''}</FormHelperText>}
                                            </Grid>


                                            <Grid item xs={6} md={6} className="pro-qty">
                                                <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                                                    Minimum Product Qty
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    variant='outlined'
                                                    value={filters?.productLimit?.min}
                                                    onChange={(e) => handleNumberInput(e, 'min')}
                                                    error={errors.minProducts || errors.maxLessThanMin}
                                                    helperText={
                                                        errors.minQtyInvalid
                                                            ? `Minimum quantity must be at least 5`
                                                            : errors.minProducts
                                                                ? 'Minimum Product Qty is required'
                                                                : errors.maxLessThanMin
                                                                    ? 'Maximum must be greater than or equal to minimum'
                                                                    : ''
                                                    }
                                                    inputProps={{ min: 1 }}
                                                />
                                            </Grid>

                                            <Grid item xs={6} md={6} className="pro-qty">
                                                <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                                                    Maximum Product Qty
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    variant='outlined'
                                                    value={filters?.productLimit?.max}
                                                    onChange={(e) => handleNumberInput(e, 'max')}
                                                    error={errors.maxProducts || errors.maxLessThanMin}
                                                    helperText={
                                                        errors.maxProducts
                                                            ? 'Maximum Product Qty is required'
                                                            : errors.maxLessThanMin
                                                                ? 'Maximum must be greater than or equal to minimum'
                                                                : ''
                                                    }
                                                    inputProps={{ min: 1 }}
                                                />
                                            </Grid>

                                        </Grid>

                                        <Stack
                                            direction="row"
                                            justifyContent="space-between"
                                            gap={2}
                                            flexWrap="wrap"
                                            mt={4}
                                            mb={1}
                                        >
                                            <Box display="flex" alignItems="center" gap={2}>
                                                <MDButton
                                                    variant="contained"
                                                    color="primary"
                                                    style={{ minWidth: "160px" }}
                                                    disabled={isupdateLoading}
                                                    loading={isupdateLoading}
                                                    onClick={() => {
                                                        handleApplyButton();
                                                    }}
                                                >
                                                    {CarouselId ? 'Update' : 'Apply'}
                                                </MDButton>

                                                {/* here is error if brand or category empty */}
                                                <MDButton
                                                    variant="outlined"
                                                    color="dark"
                                                    style={{ minWidth: "160px" }}
                                                    onClick={() => navigate(`/hyperwolf/product-carousels?platform=${fullRoleTab || 'Hyperwolf'}`, { replace: true })}
                                                >
                                                    Cancel
                                                </MDButton>
                                            </Box>
                                            <Box>
                                                <MDButton
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => handleClear()}
                                                    style={{ padding: "0", borderRadius: "0", background: "transparent", color: "#9A9AAF", fontSize: "14px", fontWeight: "600", minHeight: "auto", boxShadow: "none", textDecoration: "underline" }}
                                                >
                                                    Clear Filters
                                                </MDButton>
                                            </Box>
                                        </Stack>
                                        {errors.noSelection && (
                                            <Typography variant="caption" color="error" fontWeight="normal" sx={{ mt: 1, display: 'block' }}>
                                                Please select at least one category, brand
                                            </Typography>
                                        )}
                                    </Card>
                                </Grid>
                            }

                            {CarouselView === 'true' ?
                                <Grid item xs={12} md={12}>
                                    <ViewCarouselFilters CarouselId={CarouselId} carouselName={carouselName} storeId={storeId} filters={filters} stores={stores} />
                                </Grid>
                                :
                                <>
                                    {
                                        CarouselId &&
                                        <Grid item xs={12} md={4}>
                                            <ViewCarousel CarouselId={CarouselId} carouselName={carouselName} storeId={storeId} filters={filters} stores={stores} />
                                        </Grid>
                                    }
                                </>
                            }
                        </Grid>
                }
                {CarouselView === 'true' ?
                    <ProductTableView CarouselId={CarouselId} refreshKey={refreshKey} productLimit={filters?.productLimit} products={filters?.products} />
                    :
                    CarouselId &&
                    <ProductTable CarouselId={CarouselId} refreshKey={refreshKey} productLimit={filters?.productLimit} products={filters?.products} />
                }
            </Box>
        </CommonLayout>
    );

};
